import { useEffect } from 'react';
import Header from './header';
import Sidebadr from './sidebar';

const Layout: React.FC<any> = ({ children }) => {
  //  Set --vh variable for mobile Safari fix
  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    setVh();
    window.addEventListener('resize', setVh);
    return () => window.removeEventListener('resize', setVh);
  }, []);

  return (
    <div
      className="bg-gray-50 flex overflow-hidden"
      style={{ height: 'calc(var(--vh, 1vh) * 100)' }} // instead of h-screen
    >
      <Sidebadr />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <div className="flex-1 flex items-stretch overflow-hidden">
          <main className="flex-1 overflow-y-auto" id="main-scroll-container">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
